import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RowArgs } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';

@Component({
  selector: 'app-valid-grid',
  templateUrl: './valid-grid.component.html',
  styleUrls: ['./valid-grid.component.css']
})
export class ValidGridComponent implements OnInit {
  selectedData = [];
  gridView = [];
  enableMasterDeleteBtn: boolean;
  operators: any;
  adjustmentInputData: any;
  expandedDetailKeys = [];
  gridState: State = {
    sort: [],
    take: 10,
    skip: 0
  };

  @Input() set validAdjustmentData(data: any) {
    if (data) {
      this.loadValidGridData(data);
    }
  }
  @Input() set accessOperators(operator: any) {
    if (operator) {
      this.operators = operator;
    }
  }
  @Input() set adjustmentInputs(inputData: any) {
    if (inputData) {
      this.getReasonCode(inputData);
    }
  }
  @Output() deleteAction: EventEmitter<any> = new EventEmitter();
  @Output() addAction: EventEmitter<any> = new EventEmitter();
  @Output() editAction: EventEmitter<any> = new EventEmitter();
  @Output() childDeletedRecord: EventEmitter<any> = new EventEmitter();
  isRowSelected: (e: RowArgs) => boolean;

  constructor() { }

  ngOnInit(): void {
    this.isRowSelected = (e: RowArgs) => this.selectedData.indexOf(e.dataItem) >= 0;
  }

  getReasonCode(input: any) {
    this.adjustmentInputData = input;
  }

  loadValidGridData(dataSet: any) {
    this.gridView = dataSet;
    this.enableMasterDeleteBtn = false;
    this.expandedDetailKeys = [];
  }

  onValidMasterSelectionChange(event: any) {
    if (this.selectedData.length === 0 && event.ctrlKey === undefined) {
      if (event.selectedRows.length > 0) {
        this.selectedData = [];
        event.selectedRows.filter((element: any) => this.selectedData.push(element.dataItem));
      } else if (event.deselectedRows.length > 0) {
        this.selectedData = [];
      }
    } else {
      if (event.selectedRows.length > 0) {
        if (event.selectedRows.length > 1) {
          event.selectedRows.filter((element: any) => this.selectedData.push(element.dataItem));
        } else if (this.selectedData[0] !== event.selectedRows[0].dataItem) {
          this.selectedData.push(event.selectedRows[0].dataItem);
        }
      } else if (event.deselectedRows.length > 0) {
        if (event.deselectedRows.length > 1) {
          event.deselectedRows.filter((element: any) => {
            if (this.selectedData.indexOf(element.dataItem) > -1) {
              const index = this.selectedData.indexOf(element.dataItem);
              this.selectedData.splice(index, 1);
            }
          });
        } else {
          const index = this.selectedData.indexOf(event.deselectedRows[0].dataItem);
          this.selectedData.splice(index, 1);
        }
      }
    }
    this.isRowSelected = (e: RowArgs) => this.selectedData.indexOf(e.dataItem) >= 0;
    this.enableMasterDeleteBtn = this.selectedData && this.selectedData.length > 0;
  }

  isParentSelected(dataItem: any): boolean {
    return this.selectedData.some(x => x.ssn === dataItem.ssn);
  }

  deleteBtnClicked(event: any) {
    this.deleteAction.emit({ isDeleteClicked: event, selectedRecords: this.selectedData });
  }

  addHandler(value: any) {
    this.addAction.emit({ event: value, isAddClicked: true });
  }

  editHandler(value: any) {
    this.editAction.emit({ event: value, isAddClicked: true });
  }

  childDeleteAction(value: any) {
    this.childDeletedRecord.emit(value);
  }
}
